<div class="card card-custom instance-setting-sidebar">
    <div class="card-body accordian-section new-accordian-scroll">
        <div class="instance_title">
            <h3 class="heading_text">
                ICE Database
                <a title="Back to Root" (click)="backToHome()"
                    ><img src="../../../../../../assets/media/logos/back-icon.png" alt="back-icon" class="imgReply"
                /></a>
            </h3>
            <hr />
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="section">
                    <div class="instance_data">
                        <div *ngFor="let item of databaseDetails">
                            <div class="plant-section">
                                <div class="child_section" [class.background-highlight]="item.name == selectedTableData?.name">
                                    <p>
                                        <a (click)="selectedTableItem(item)">{{ item.name }} </a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr />

                <div *ngIf="selectedTableData">
                    <h4>{{ selectedTableData.name }}</h4>
                    <div class="filter_section search-wrapper mb-4">
                        <mat-form-field>
                            <input matInput type="text" placeholder="Search" (keyup)="searchResult($event)" [(ngModel)]="searchInput" />
                            <button mat-button matPrefix mat-icon-button class="search_btn">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="section">
                        <div class="instance_data">
                            <div *ngFor="let item of copySelectedTableData.tableList">
                                <div class="plant-section">
                                    <div class="child_section" [class.background-highlight]="item?.name === selectedTable">
                                        <p>
                                            <a (click)="selectedTableName(item.name)">{{ item.name }} </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="add_more" *ngIf="selectedTableData.tableList?.length > 5">
                        <a href="javascript:void(0)" (click)="table_moreData()">MORE +</a>
                    </div>
                </div>

                <div class="menulist" *ngIf="selectedTable">
                    <hr />
                    <h4>{{ selectedTable }}</h4>
                    <div class="filter_section search-wrapper mb-4">
                        <mat-form-field>
                            <input matInput type="text" placeholder="Search" (keyup)="searchTableResult($event)" [(ngModel)]="searchTableInput" />
                            <button mat-button matPrefix mat-icon-button class="search_btn">
                                <mat-icon>search</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <h6>Parent Tables</h6>
                    <div class="section">
                        <div class="instance_data">
                            <div *ngFor="let item of copyParentTableList">
                                <div class="plant-section">
                                    <div class="child_section">
                                        <p>
                                            <a (click)="selectedTableName(item.parentTableName)">{{ item.parentTableName }} </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <h6>Child Tables</h6>
                    <div class="section">
                        <div class="instance_data">
                            <div *ngFor="let item of copyChildTableList">
                                <div class="plant-section">
                                    <div class="child_section">
                                        <p>
                                            <a (click)="selectedTableName(item.childTableName)">{{ item.childTableName }} </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
